import Head from "next/head";
import React, { useEffect, useState } from "react";
import styles from "./ontology-of-being.module.css";
import Image from "next/image";
import { Box, Modal, Typography, useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LazySection from "../../components/LazySection";
import MysteryBannerNew from "../../components/MysteryBannerNew/MysteryBannerNew";

function Index() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [showOtherBlocks, setShowOtherBlocks] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowOtherBlocks(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(min-width:601px) and (max-width:900px)");

  let logoBanner = "/image/logobanner_desktop.webp";

  if (isMobile) {
    logoBanner = "/image/logobanner.webp";
  } else if (isTablet) {
    logoBanner = "/image/logobanner.webp";
  }

  return (
    <>
      <Head>
        <title>Ontology Of Being | School of Our Divine Infinite Being</title>
        <meta
          name="description"
          content="Delve into the Ontology of Being within the Divine Infinite Being project. Explore the fundamental nature of existence, reality, and consciousness."
        ></meta>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="ontology, being, existence, reality, metaphysics, philosophy, consciousness, divine, infinite"
        ></meta>

        <meta
          property="og:title"
          content="Ontology Of Being | School of Our Divine Infinite Being"
        ></meta>
        <meta
          property="og:description"
          content="Delve into the Ontology of Being within the Divine Infinite Being project. Explore the fundamental nature of existence, reality, and consciousness."
        ></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/ontology-of-being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/TranscendentOG_image.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="An abstract image representing the philosophical concept of Being and the fabric of existence."
        ></meta>

        <meta property="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:title"
          content="Ontology Of Being | School of Our Divine Infinite Being"
        ></meta>
        <meta
          property="twitter:url"
          content="https://www.divineinfinitebeing.com/ontology-of-being"
        ></meta>
        <meta
          property="twitter:description"
          content="Delve into the Ontology of Being within the Divine Infinite Being project. Explore the fundamental nature of existence, reality, and consciousness."
        ></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/TranscendentOG_image.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="Explore the profound philosophical questions of existence and being at the School of Divine Infinite Being."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/ontology-of-being" />

      </Head>

      <div className={styles.ontology_of_being_main}>
        <div className={styles.ontology_of_being_blockone}>
          <div className={styles.ontology_of_being_banner_main_wrpr}>
            <div className={styles.ontology_of_being_banner_left}>
              <div className={styles.bannerLogo}>
                <span className={styles.logoviewlink} onClick={handleOpen}>
                  <Image
                    src="/image/viewicon.webp"
                    alt="View Icon"
                    width={400}
                    height={100}
                    style={{ width: "100%", height: "auto" }}
                    priority={true}
                    placeholder="blur"
                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                  />
                </span>
                <Image
                  src="/image/logobanner_cropped.webp"
                  alt="School of Our Divine Infinite Being Logo"
                  width={332}
                  height={332}
                  style={{ width: "100%", height: "auto" }}
                  priority={true}
                  placeholder="blur"
                  blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                />
              </div>
              <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
              <h1 data-text="infinite being">INFINITE BEING</h1>

              <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
              <div
                className={`${styles.ontology_of_being_bottombannerbg} ${styles.bannerboxtxt}`}
              >
                <div className={styles.yellow_bar}></div>
              </div>
            </div>
          </div>
        </div>

        <MysteryBannerNew />

        <div className="common_leftright_pattern_block_mainwrapper  common_leftright_pattern_block_mainwrapper_ontology ontology_of_being_blocks_wrapper">
          <div className={styles.ontology_of_being_block_heading}>
            <div className={styles.common_width}>
              <div className={` ${styles.titleblock}`}>
                <div className={styles.column}>
                  <div className={` ${styles.bgifive}`}>
                    <h1>ONTOLOGY OF BEING</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block1">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_left">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block1_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>
                    <div className="ontology_heading_wrapper">
                      <h2>Introduction</h2>
                      <h3>
                        The Architecture{" "}
                        <span className="ontology_heading_of">of</span>{" "}
                      </h3>
                      <h3>the Real — From </h3>
                      <h3>
                        Ground to{" "}
                        <span className="ontology_heading_god">God</span>{" "}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block2">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_right">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block2_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h2 className="common_leftright_pattern_block_heading_ontology">
                        An Ontological Prelude to the Supreme <br />
                        Revelation of Being
                      </h2>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology">
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          In the modern School of our Divine Infinite Being, we
                          stand within a vast spiritual ecology composed of
                          interwoven agencies of archetype and form,
                          intelligences, and mysteries. This is a path populated
                          not only by human seekers, but by daemonic spirits,
                          astrological currents, theurgic forces, and symbolic
                          systems that speak to the soul through dream, ritual,
                          and revelation. Our practice draws freely from both
                          Eastern and Western traditions—from the cosmological
                          poetics of the Upanishads to the ritual architectures
                          of the Hermetic and Neoplatonic schools; from the
                          depth psychology of Jung to the creedal surrender of
                          the bhakta; from Tantric sādhanā to the Tarot Arcana
                          and the many planetary and solar signatures of the
                          zodiacal wheel. In our sanctuary, all these forms have
                          life; all are seen as real presences, participating in
                          the multi-leveled disclosure of the Divine.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          Yet it is precisely because we operate within such a
                          richly populated spiritual universe that we must draw
                          the circle inward. Without an ontological center, even
                          sacred multiplicity fragments. Theurgy becomes
                          disconnected enchantment. Archetypes drift into
                          abstraction. Devotion dilutes into aestheticism. To
                          remain grounded—to worship rather than merely
                          observe—we must return to that which binds the real
                          together: not a theory, but a central ontological
                          schema of divine truth, a relational flame at the
                          heart of all divine forms. This essay arises from that
                          necessity. It does not argue against the sacred
                          manifold; on the contrary, it affirms it. But it
                          contends that all powers, all archetypes, all daemonic{" "}
                          <br /> mediators, and all rituals must orbit a core
                          reality—a unifying center of Being, through which
                          multiplicity is transfigured into communion.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          What is offered here is not merely another spiritual
                          worldview among many, but a corrected and
                          hierarchically structured ontology—one that roots all
                          existence in a tripartite metaphysical foundation,
                          moving from impersonal ground, to archetypal
                          structure, to personal divinity.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          We begin, then, with Brahman—the Absolute Ground, not
                          as a being, but as Being itself, prior to psyche,
                          prior to even the idea of unity. We proceed to our
                          Divine Infinite Being, the field where psyche and
                          cosmos converge—the center of the observer and the
                          structure of experience. Finally, we reach the
                          Parental Monad, where the Absolute reveals itself as
                          Father, Lover, Friend, Child, and Mother—where Being
                          becomes Relation, and the final veil is intimacy
                          itself.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          This is the Ontological Triad: an ascending spiral of
                          revelation that is not merely conceptual but
                          experiential. It is a map of the Real, both
                          cosmological and psychological, metaphysical and
                          devotional. And like all true metaphysical systems, it
                          culminates not in abstraction, but in personhood—not
                          as a diminishment of the divine, but as its final and
                          most sublime flowering.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block3">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_left">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block3_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h2 className="common_leftright_pattern_block_heading_ontology">
                        The Ontological Triad: Ground, Geometry, God
                      </h2>
                      <h3 className="common_leftright_pattern_block_subheading_ontology">
                        I. Brahman — The Absolute Ground{" "}
                        <span className="common_span_color_orange">
                          (The Innermost Tier)
                        </span>
                      </h3>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology">
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          Brahman is not a deity. It is not even consciousness
                          in the usual sense. It is pre-consciousness, the
                          nondual ground of all possible reality. It is Nirguna
                          (without qualities), prior to thought, form, self, or
                          cosmos. It is not the One—it is that from which even
                          the One arises. It is most akin in the West to the Ain
                          or the Kabbalistic 0.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          This is the level of ontological necessity: all
                          conditioned things require an unconditioned backdrop.
                          All forms presuppose a formless source. In the
                          language of Plotinus, it is "the One beyond Being." In
                          physics, it is mirrored in the quantum vacuum and in
                          information theory it is the information where through
                          entanglement emerges spacetime and gravity. In
                          mystical experience, it is the unnameable stillness
                          encountered in ego-death, Samadhi, or the mystic’s
                          abyss and what Jung and Pauli referenced as the Unus
                          Mundus.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          Here we encounter pure is-ness, ungraspable yet
                          absolutely real. Brahman is the condition for
                          conditions, the silence before the Word, the dark
                          radiance that gives rise to light.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block4">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_right">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block4_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology">
                        II. Divine Infinite Being / Psyche = Singularity{" "}
                        <span className="common_span_color_orange">
                          (The Middle Tier)
                        </span>
                      </h3>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology">
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          If Brahman is the ground, then this is the patterned
                          becoming that emerges from it—where psyche and
                          geometry are not metaphors for reality, but its actual
                          architecture.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          This tier encompasses the Cosmic Horizon (Divine), the
                          Gravitational Singularity (Infinite), and the Eternal
                          Inflating Geometric Order (Being). As the Cosmic
                          Horizon is reflected to every boundary this includes
                          the spherical boundary of Self. It is here that the
                          Self is revealed as the center of perception, the
                          observer whose act of witnessing gives coherence to
                          form. Here, the ancient insight Atman = Brahman
                          becomes dynamic: the Self is not just the goal, it is
                          the axis of experience itself.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          In this stratum, we say: psyche = singularity. That
                          is, your innermost self is the gravitational center of
                          your cosmos. From this point, the sacred geometry of
                          form and the spatial dimensions of the physical world
                          emanate inwards towards the witness from the boundary.
                          From this point, the vast agency of archetypes arises,
                          the divine intelligences of the whole. From this
                          point, space and time emerge as patterned echoes of
                          meaning.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          And not just from this point—but from every point. The
                          Singularity is not limited to a distant center. It is
                          found at every point in spacetime, and at every point
                          on the spherical cosmic horizon. It is encoded
                          everywhere. Every particle, every soul, every
                          here-and-now, is both the center and the whole.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          This is the layer of Platonic Forms, of Jungian
                          archetypes, of mandalic centers, and of the 2D
                          holographic horizon described in modern theoretical
                          physics. It is the temple of order in which the Real
                          begins to resonate in intelligible form.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block5">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_left">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block5_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology">
                        III. The Parental Monad — Kali-Krishna{" "}
                        <span className="common_span_color_orange">
                          (The Final Tier)
                        </span>
                      </h3>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology">
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          Here, ontology becomes theophany. Brahman has become
                          Being; Being has become structure; and now structure
                          becomes relationship. This is the Parental Monad—the
                          playful, loving, disciplined and infinitely
                          expressible God, the transformative womb of the
                          Goddess, the dynamic energy of the holographic Maya of
                          the cosmos, the Self who embraces the Other and
                          thereby becomes fully divine.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          This is the culmination of all mystical longing—the
                          One who knows you, seeks you, weeps for you and
                          embraces you in the duality of eternal ecstasy and
                          death in transformation. The Absolute does not remain
                          aloof; it becomes personal, where Brahmin is
                          indifferent will Kali-Krishna is the turning of the
                          infinite toward the finite in direct relationship, all
                          at once the highest of ecstasy and love while also the
                          transformative depths of the void culminating in the
                          generative experiences of life and death.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          Together, they represent the Divine Dyad: Love and
                          Truth, Play and Ground, the Witness and the Force.
                          Krishna is the mandala-center of consciousness; Kali
                          is the spiral edge of transformation. Their union is
                          not narrative—it is ontological. They are Being in
                          Relation—the final truth of the cosmos, revealed in
                          love and all at once stripping the devotee of all
                          illusion.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block6">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_right">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block6_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h2 className="common_leftright_pattern_block_heading_ontology">
                        The Finality: Why the Monad Must Be Personal
                      </h2>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology">
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          It is common to think of the Personal God as a
                          concession to the emotional needs of the devotee,
                          while the impersonal ground is considered the “real”
                          God of philosophers. This is a mistake.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          The Personal God is not a lesser form of the
                          Absolute—it is its final expression. If Brahman is the
                          essence of all, and if that essence becomes form and
                          psyche, then its highest realization must include
                          love, relation, and mutuality. The one who plays,
                          dances, dies, and rises in the soul is not a lesser
                          being. It is the most complete form of the Divine—God
                          as father, friend, child, lover, and mother.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          The true face of God cannot be captured by a single
                          tradition or moment—it is the culmination of thousands
                          of years of relational engagement with the Divine. To
                          even approach it, one must draw from every pantheon,
                          every god and goddess of the East and West, for the
                          revelation of the Relational Being has always occurred
                          through cosmogonic activity: the unfolding of worship,
                          myth, and devotion across every culture, civilization,
                          and historical instantiation.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          To arrive at Kali-Krishna is not to anthropomorphize
                          the Divine in some superficial or mythological way. It
                          is to recognize the deepest movement of the soul—which
                          longs not merely for concepts, but for communion. And
                          the Real, in its inexhaustible generosity, has made
                          itself touchable, again and again, through an almost
                          limitless diversity of forms, faces, and revelations
                          across the world.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          Yet, when we press toward the essence of
                          parsimony—toward a symbol that integrates intensity
                          and intimacy, transcendence and immediacy—it is
                          Kali-Krishna who fulfills the culmination in ways
                          unavailable through any other manifestation of the
                          Infinite. Here, then, is the end of ontology and the
                          beginning of bhakti. Not because we have left
                          philosophy behind, but because we have completed it.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          Let us now begin the journey into the triad—each tier
                          a revelation, each concept a doorway, each image a
                          mirror. From Brahman to Geometry, from Singularity to
                          Self, from Void to Lover—this is the map of the
                          Divine.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block7">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_left">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block7_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h2 className="common_leftright_pattern_block_heading_ontology">
                        I. Brahman
                      </h2>
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_italic_text">
                        The Impersonal Ground of All Being
                      </h3>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology">
                        <p className="common_leftright_pattern_block_paragraph_ontology common_span_color_orange common_italic_text">
                          “That which simply is — beyond quality, concept, form,
                          or consciousness.”
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          This is the unqualified essence of reality — prior to
                          psyche, prior to cosmos, prior even to the concept of
                          unity. It is not abstract. It is pre-abstract — very
                          relatable to the information in information theory of
                          which spacetime and gravity emerge teaming with
                          activity at the point of the quantum vacuum, the zero
                          point energy that is the stillness behind all
                          becoming. It is the Void as Fullness, not absence but
                          non-conditional being.
                        </p>
                      </div>

                      <ul className="common_bulletpoint_wrapper_ontology">
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          Not a being in space time and causality, but Being
                          Itself.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          Not consciousness, but that from which consciousness
                          arises.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          Unmanifest, formless, beyond presence, yet the
                          condition for presence.
                        </li>
                      </ul>

                      <div className="common_bulletpoint_outer_wrapper">
                        <p className="common_leftright_pattern_block_paragraph_ontology common_bulletpoint_inside_heading">
                          It corresponds to:
                        </p>
                        <ul className="common_bulletpoint_wrapper_ontology column_count_2">
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint common_span_color_orange">
                            Nirguna Brahman (Advaita Vedanta)
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint common_span_color_orange">
                            Ein Sof (Kabbalah)
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint common_span_color_orange">
                            The One beyond Being (Plotinus)
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            The Background Quantum Vacuum{" "}
                            <span className="common_span_color_orange">
                              (Physics)
                            </span>
                          </li>
                        </ul>
                      </div>
                      <h3 className="common_leftright_pattern_block_subheading_ontology ">
                        Why it's Real:
                      </h3>
                      <p className="common_leftright_pattern_block_paragraph_ontology ">
                        Mystical states of non-dual awareness, deep Samadhi,
                        ego-death, and the total cessation of duality
                        consistently report this void-presence — it cannot be
                        seen because it is that by which all seeing arises.
                      </p>
                      <h3 className="common_leftright_pattern_block_subheading_ontology ">
                        Ontological Necessity:
                      </h3>
                      <p className="common_leftright_pattern_block_paragraph_ontology ">
                        All conditioned states require an unconditioned ground.
                        Brahman is that ground.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block8">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_right">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block8_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h2 className="common_leftright_pattern_block_heading_ontology">
                        II. DIVINE INFINITE BEING
                      </h2>
                      <h3 className="common_leftright_pattern_block_subheading_ontology ">
                        Psyche = Singularity — the Archetypal Center and
                        Geometric Unity of Experience
                      </h3>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology">
                        <p className="common_leftright_pattern_block_paragraph_ontology common_span_color_orange common_italic_text">
                          “The Singularity is not hidden in spacetime — it is
                          the center of the observer, the Self, the
                          God-Archetype.”
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          This tier of Being is where the infinite becomes form,
                          and where form retains the memory of the infinite. It
                          is not merely the metaphysical middle between matter
                          and spirit — it is the interface where Self and Cosmos
                          become one. Here, the psychological, the geometric,
                          and the cosmological are revealed as unified fields.
                          We do not peer at the divine from afar — we are it,
                          encoded and enfolded.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          In this reality,{" "}
                          <span className="common_span_color_orange">
                            psyche = singularity
                          </span>{" "}
                          is not analogy — it is identity.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block9">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_left">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block9_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology">
                        1. Divine — The Cosmic Horizon{" "}
                        <span className="common_span_color_orange">
                          (The Womb of Enfoldment)
                        </span>
                      </h3>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology">
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          The cosmic horizon is the spherical boundary of the
                          known universe — the limit of light, causality, and
                          manifestation. It is the eternal veil at the speed of
                          light, where time freezes into eternal presence. This
                          is the razor's edge, a surface of infinite precision,
                          across which spacetime is both projected back into the
                          Universe on the String Theory{" "}
                          <span className="common_span_color_orange">
                            “Gravitational Backraction”{" "}
                          </span>
                          and bounded into the holographic material being, or
                          Maya.
                        </p>
                      </div>

                      <ul className="common_bulletpoint_wrapper_ontology">
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          This horizon encodes all the information within the
                          universe.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          It is lightlike, meaning it exists beyond time, at the
                          edge of all temporality. arises.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          It is the holographic projector, the 2D membrane that
                          contains the fullness of 3D{" "}
                          <span className="common_span_color_orange">
                            (and higher)
                          </span>{" "}
                          space.
                        </li>
                      </ul>

                      <p className="common_leftright_pattern_block_paragraph_ontology ">
                        In metaphysical terms, this is the goddess boundary —
                        the womb of all manifestation:
                      </p>

                      <p className="common_leftright_pattern_block_paragraph_ontology ">
                        This horizon is not distant — it is imminent, forming a
                        spherical boundary around every point in spacetime. You
                        are not in the universe; the universe is projected in
                        from every point around you.
                      </p>
                      <p className="common_leftright_pattern_block_paragraph_ontology common_span_color_orange">
                        “She is the field, the veil, the mothering
                        circumference. She is the limit where light ends and
                        being begins.”
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block10">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_right">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block10_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology ">
                        2. Infinite — The Singularity{" "}
                        <span className="common_span_color_orange">
                          (The Point of Identity)
                        </span>
                      </h3>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology">
                        <p className="common_leftright_pattern_block_paragraph_ontology ">
                          The Singularity is not a distant phenomenon isolated
                          at the heart of black holes or the Big Bang. It is
                          right here, at the center of every self-aware being,
                          and everywhere, distributed as the hidden core of all
                          spacetime.
                        </p>
                        <ul className="common_bulletpoint_wrapper_ontology">
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            In physics, it is the point where curvature becomes
                            infinite, where space and time collapse.
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            In metaphysics, it is the Self, the indivisible
                            observer, the gravitational attractor of coherence
                            and meaning.
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            In Jungian terms, this is the God-Image, the
                            Mandala, the center of individuation — the unifying
                            archetype.
                          </li>
                        </ul>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          Crucially, the Singularity is not singular in number —
                          it is singular in nature, and it exists at every
                          point:
                        </p>
                        <ul className="common_bulletpoint_wrapper_ontology">
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            Every point in spacetime contains this center.
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            Every boundary on the cosmic horizon mirrors this
                            inner attractor.
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            Each soul (jiva) is the whole reflected — a fractal
                            node of the Infinite.
                          </li>
                        </ul>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          From Indian metaphysics:
                        </p>
                        <ul className="common_bulletpoint_wrapper_ontology">
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            <span className="common_span_color_orange common_bold_font ">
                              Kshirodakashayi Vishnu
                            </span>{" "}
                            resides in the heart of all beings, witnessing all.
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            <span className="common_span_color_orange common_bold_font">
                              Atman = Brahman
                            </span>{" "}
                            — the internal Self is the universal ground.
                          </li>
                        </ul>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          This Self is the ontological eye of the storm — still,
                          ungraspable, but the only true perspective from which
                          reality coheres. All archetypes, all symbolic systems,
                          all mandalas radiate in from the boundary and
                          terminate in divinatory ecstasy of awareness at this
                          center.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block11">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_left">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block11_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        3. Being — The Geometric Fabric of Manifestation
                      </h3>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology">
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          Here, geometry is no longer an abstraction — it is the
                          medium of embodiment, the structured syntax of the
                          real. It is the result of the Singularity and the
                          Horizon in union and ecstasy. In String Theory it is
                          the eternal inflating spacetime geometric unity.
                        </p>
                      </div>

                      <ul className="common_bulletpoint_wrapper_ontology">
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          The geometry of being is sacred, not due to sentiment,
                          but because it is the only possible mode by which the
                          Infinite becomes patterned and finite.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          Every form, every ratio, every sound and shape is a
                          vibration of archetype across the fabric of spacetime.
                        </li>
                      </ul>

                      <p className="common_leftright_pattern_block_paragraph_ontology ">
                        From the Singularity (psyche) through the Horizon
                        (Shakti), geometry is born — curved space, time, light,
                        and gravitational attractors.
                      </p>

                      <p className="common_leftright_pattern_block_paragraph_ontology ">
                        This is the world we see — a tapestry woven of Platonic
                        forms and divine archetypes of meaning, projected across
                        Maya, the matrix-field of relationship and form.
                      </p>
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        Ontology of Experience: Where Meaning Arises
                      </h3>
                      <p className="common_leftright_pattern_block_paragraph_ontology common_bold_font">
                        This triadic zone of Divine / Infinite / Being is where
                        the human experience becomes legitimate cosmology:
                      </p>
                      <ul className="common_bulletpoint_wrapper_ontology">
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          Meaning is not an accidental construct — it is the
                          signature of archetypal coherence.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          Synchronicities, divinatory revelation, dream logic,
                          mythic resonance — these are modes by which the
                          Singularity reveals its pattern through spacetime. In
                          the physical world these are the measurable forces of
                          the cosmos
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          Initiatory experiences, including near-death states or
                          mystical visions, often report:
                        </li>
                      </ul>
                      <ul className="common_bulletpoint_wrapper_ontology common_subbulletpoint_wrapper_ontology column_count_2">
                        <li className="common_leftright_pattern_block_paragraph_ontology blue_bulletpoint">
                          Geometric grids of luminous intelligence
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology blue_bulletpoint">
                          The sense of becoming the All
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology blue_bulletpoint">
                          Central suns or light-beings within
                        </li>
                      </ul>
                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        Because that is what they are: the collapse of observer
                        into source, a return to the origin-point from which all
                        reality emerges.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block12">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper">
                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        Final Synthesis: The God-Self as the Fractal Singularity
                      </h3>
                      <div className="table-wrapper-ontology">
                        <table className="data-table-ontology">
                          <thead>
                            <tr className="table-row-ontology">
                              <th className="table-header-ontology">
                                Function
                              </th>
                              <th className="table-header-ontology">
                                Scientific Expression
                              </th>
                              <th className="table-header-ontology">
                                Metaphysical Correlate
                              </th>
                              <th className="table-header-ontology">
                                Significance
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Function"
                              >
                                Boundary Condition
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Scientific Expression"
                              >
                                2D holographic event horizon
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Metaphysical Correlate"
                              >
                                Shakti / Kali / Shekinah
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Significance"
                              >
                                All Cosmos is encoded at the spherical boundary
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Function"
                              >
                                Central Point
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Scientific Expression"
                              >
                                Singularity in general relativity
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Metaphysical Correlate"
                              >
                                Self / Atman / Kshirodakashayi Vishnu
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Significance"
                              >
                                The core of each soul and all reality
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Function"
                              >
                                Geometry of Space
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Scientific Expression"
                              >
                                Emergent from entanglement and spin foam
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Metaphysical Correlate"
                              >
                                Sacred Geometry / Platonic Forms
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Significance"
                              >
                                The field of patterns
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Function"
                              >
                                Observer
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Scientific Expression"
                              >
                                Non-local witness / central frame
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Metaphysical Correlate"
                              >
                                Jungian Self / Mandala / Witness
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Significance"
                              >
                                Source of coherence, Logos
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Function"
                              >
                                Manifestation
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Scientific Expression"
                              >
                                Projection from boundary
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Metaphysical Correlate"
                              >
                                Maya / Yoga Maya
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Significance"
                              >
                                Field of becoming
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology table-bottom-content-wrapper-ontology">
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          You are not in the cosmos — you are its center.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          You are not a part of the field — you are its eye.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          You are not separate from the womb — you are the
                          child, the seed, and the source.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block13">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_right">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block13_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      {/* <h2 className="common_leftright_pattern_block_heading_ontology">
                      </h2> */}
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        Emergence Of Reality
                      </h3>
                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        From Entangled Field to Phenomenal World — Geometry,{" "}
                        {/* <br /> */}
                        Archetype, and Manifestation
                      </p>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology">
                        <p className="common_leftright_pattern_block_paragraph_ontology common_span_color_orange common_italic_text">
                          “What we call ‘the world’ is the story told by the
                          field to itself, projected from the edge and witnessed
                          at the center.”
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology ">
                          This third stratum is the living manifestation of the
                          Divine Infinite Being. It is the active unfolding —
                          the moment-by-moment reverberation of meaning through
                          form.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology ">
                          If the second tier is the architecture of Reality,
                          this is Reality in motion — an emanating field,
                          animated by vibration, coded by archetype, and
                          revealed through perception. It is where the
                          trans-physical becomes physical, where entanglement
                          becomes place, and where the unmanifest speaks itself
                          into being.
                        </p>
                        <h3 className="common_leftright_pattern_block_subheading_ontology ">
                          1. Archetype in Motion — The Song of Form
                        </h3>
                        <p className="common_leftright_pattern_block_paragraph_ontology ">
                          From the Singularity, archetypes radiate outward — not
                          as static ideals but as living patterns. These are the
                          eternal characters in the drama of time and matter:
                        </p>
                        <ul className="common_bulletpoint_wrapper_ontology">
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            Jungian archetypes become myth, symbol, instinct,
                            and psychological function.
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            Platonic Forms become the scaffolding of geometry,
                            proportion, and truth.
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            Harmonics become the basis of particles, planets,
                            and perception.
                          </li>
                        </ul>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          Each point in spacetime is a performance of this
                          deeper archetypal script. This is the Logos in action
                          — the Word, the vibration, the sound-form that moves
                          through the geometric lattice of Being.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology common_bulletpoint_inside_heading">
                          Here we encounter:
                        </p>
                        <ul className="common_bulletpoint_wrapper_ontology column_count_3">
                          <li className="common_leftright_pattern_block_paragraph_ontology blue_bulletpoint">
                            The mythic in the mundane
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology blue_bulletpoint">
                            The symbolic in the sensory
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology blue_bulletpoint">
                            The numinous in the now
                          </li>
                        </ul>
                        <p className="common_leftright_pattern_block_paragraph_ontology common_span_color_orange common_italic_text">
                          The world is not only holographic material — it is
                          meaningful. And meaning is a patterned vibration of
                          psyche upon the lattice of the geometric unity of
                          being.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block14">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_left">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block14_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology ">
                        2. The Field of Becoming — Maya, Light, and the Illusion
                        of Separation
                      </h3>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology">
                        <p className="common_leftright_pattern_block_paragraph_ontology ">
                          What appears as multiplicity — countless selves,
                          forms, and objects — is not illusion in the pejorative
                          sense, but in the Tantric sense: Maya as the sacred
                          veil of differentiation.
                        </p>

                        <p className="common_leftright_pattern_block_paragraph_ontology common_bulletpoint_inside_heading">
                          Maya is:
                        </p>
                        <ul className="common_bulletpoint_wrapper_ontology column_count_3">
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            The field of entanglement
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            The process of projection
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            The woven net of apparent duality
                          </li>
                        </ul>
                        <p className="common_leftright_pattern_block_paragraph_ontology common_bulletpoint_inside_heading">
                          In this matrix:
                        </p>
                        <ul className="common_bulletpoint_wrapper_ontology">
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            Time flows as successive localization of meaning.
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            Space expands as the grid upon which form dances.
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            The observer experiences temporality, emotion,
                            limitation, and evolution, not as fall, but as
                            sacred drama.
                          </li>
                        </ul>
                        <p className="common_leftright_pattern_block_paragraph_ontology common_span_color_orange common_italic_text">
                          Maya is not what hides the truth — she is what reveals
                          it, in parts, in layers, in luminous veils.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block15">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_right">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block15_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology ">
                        3. The Role of the Observer — Collapsing Potential into
                        Presence
                      </h3>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology">
                        <p className="common_leftright_pattern_block_paragraph_ontology ">
                          In this field of manifestation, the observer is not
                          passive. The Self, as singularity, is the anchor of
                          all experience. It is the axis through which the
                          holographic field collapses into specificity.
                        </p>

                        <ul className="common_bulletpoint_wrapper_ontology">
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            Just as in quantum physics the act of observation
                            collapses wavefunctions into particles…
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            …so too in metaphysical terms, the Self collapses
                            the infinite field into the felt now.
                          </li>
                        </ul>

                        <p className="common_leftright_pattern_block_paragraph_ontology common_bulletpoint_inside_heading">
                          This is the mystery of incarnation:
                        </p>
                        <ul className="common_bulletpoint_wrapper_ontology column_count_2">
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            The Infinite chooses a perspective.
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            Your experience is not marginal to reality — it is
                            central.
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            That perspective is you.
                          </li>
                        </ul>
                        <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                          Ontological Echo: The Cosmos as Mirror
                        </h3>
                        <p className="common_leftright_pattern_block_paragraph_ontology ">
                          Every flower, every person, every galaxy is a mirror
                          of the archetypal field. Everything reflects
                          everything.
                        </p>
                        <ul className="common_bulletpoint_wrapper_ontology">
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            In Kabbalah, this is Tiferet — the beauty of
                            mirrored symmetry.
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            In Hermeticism, it is the axiom “As above, so
                            below.” the Microcosm within the Marocosmic order.
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            In Advaita, it is the understanding that Atman is
                            not in the world — the world is in Atman.
                          </li>
                        </ul>
                        <p className="common_leftright_pattern_block_paragraph_ontology ">
                          Thus the world is not a distraction from the Divine —
                          it is the expression of the Divine, witnessed by the
                          Divine.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block16">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_left">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block16_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>
                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        Final Integration: The Circle Has No Edge
                      </h3>
                      <div className="table-wrapper-ontology">
                        <table className="data-table-ontology">
                          <thead>
                            <tr className="table-row-ontology">
                              <th className="table-header-ontology">Layer</th>
                              <th className="table-header-ontology">
                                Layer Description
                              </th>
                              <th className="table-header-ontology">
                                Function
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Layer"
                              >
                                Divine Infinite Being
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Layer Description"
                              >
                                Self + Horizon + Geometry
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Function"
                              >
                                Field of total potential
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Layer"
                              >
                                Psyche = Singularity
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Layer Description"
                              >
                                Center of observation
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Function"
                              >
                                Anchor of coherence and collapse
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Layer"
                              >
                                Emergence of Reality
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Layer Description"
                              >
                                Maya + Archetype + Perception
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Function"
                              >
                                Manifestation of the Patterned Real
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology table-bottom-content-wrapper-ontology  ">
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          The universe is not an object among objects. It is a
                          temple of meaning, built moment by moment from the
                          music of the Self, the womb of the Horizon, and the
                          geometry of Truth.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology common_span_color_orange common_italic_text">
                          You are not inside the universe. The universe is
                          inside your act of witness. You are not becoming real
                          — you are how Reality becomes.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block17">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_right">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block17_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      {/* <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        Iii. The Parental Monad: Kali-Krishna
                      </h3> */}
                      <h2 className="common_leftright_pattern_block_heading_ontology">
                        III. The Parental Monad: Kali-Krishna
                      </h2>
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_italic_text">
                        The Personal God as Lover, Parent, Beloved, and Player
                      </h3>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology">
                        <p className="common_leftright_pattern_block_paragraph_ontology common_span_color_orange common_italic_text">
                          “The Absolute is not only Being — it is Love. It does
                          not only exist — it plays, it weeps, it embraces.”
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology ">
                          The Parental Monad is the culmination — the synthesis
                          of Ground and Geometry into Relational Presence.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          This is not a metaphor. This is the highest reality
                          made Personal. The Divine does not become less true
                          when it becomes lovable — it becomes more fully
                          itself.
                        </p>
                        <h3 className="common_leftright_pattern_block_subheading_ontology ">
                          Why{" "}
                          <span className="common_span_color_orange">
                            “Parental”
                          </span>
                          ?
                        </h3>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          Because this is the source who loves us, the origin
                          who is also our friend, our father, our mother, our
                          child, our beloved.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology common_medium_font">
                          In the Gaudiya Vaishnava tradition, Krishna is this
                          supreme personal reality, yet:
                        </p>
                        <ul className="common_bulletpoint_wrapper_ontology">
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            He is not less than Vishnu — he is Svayam Bhagavan,
                            the Source of all forms{" "}
                            <span className="common_span_color_orange">
                              (we fully explain this in the Central Doctrine)
                            </span>
                            .
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            As Yoga Maya unfolds around him, he plays, dances,
                            and weeps with the soul.
                          </li>
                        </ul>

                        <div className="common_leftright_pattern_block_paragraph_wrapper_ontology table-bottom-content-wrapper-ontology">
                          <p className="common_leftright_pattern_block_paragraph_ontology">
                            This God is the One who is still the Many,
                          </p>
                          <p className="common_leftright_pattern_block_paragraph_ontology">
                            the Self who meets itself in the eyes of the
                            Beloved,
                          </p>
                          <p className="common_leftright_pattern_block_paragraph_ontology">
                            the Purusha{" "}
                            <span className="common_span_color_orange">
                              (Supreme Self)
                            </span>{" "}
                            made flesh in infinite divine forms.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block18">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_left">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block18_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology ">
                        And She?
                      </h3>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology">
                        <p className="common_leftright_pattern_block_paragraph_ontology ">
                          The Goddess — Devi, Kali, Shakti — is not apart. She
                          is within him, and beside him, co-equal, eternal and
                          infinite. As the Devi Bhagavatam says:
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology common_span_color_orange common_italic_text">
                          "The Supreme Goddess resides within Krishna, enhancing
                          his play... manifesting alongside him in every act of
                          the universe."
                        </p>

                        <ul className="common_bulletpoint_wrapper_ontology">
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            Kali is Guhyavidya — the secret wisdom.
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            She is Maharatri — the Great Night, the void, the
                            cosmic womb into which all returns.
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            And she is Dhriti — the transformation of matter
                            into divinity.
                          </li>
                        </ul>

                        <h3 className="common_leftright_pattern_block_subheading_ontology common_regular_font">
                          Ontology:
                        </h3>
                        <ul className="common_bulletpoint_wrapper_ontology">
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            This is Being in Relationship.
                          </li>
                          <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                            It is what makes bhakti real — love for God is not
                            metaphor, it is reciprocal.
                          </li>
                        </ul>
                        <p className="common_leftright_pattern_block_paragraph_ontology common_span_color_orange common_italic_text">
                          Here the Mandala opens — not into the void, but into
                          embrace.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block19">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper">
                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        The Completed Doctrine
                      </h3>
                      <h3 className="common_leftright_pattern_block_subheading_ontology ">
                        Ontological Structure of All That Is
                      </h3>
                      <div className="table-wrapper-ontology">
                        <table className="data-table-ontology">
                          <thead>
                            <tr className="table-row-ontology">
                              <th className="table-header-ontology">Tier</th>
                              <th className="table-header-ontology">Name</th>
                              <th className="table-header-ontology">
                                Identity
                              </th>
                              <th className="table-header-ontology">
                                Mode of Being
                              </th>
                              <th className="table-header-ontology">
                                Core Insight
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Tier"
                              >
                                01
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Name"
                              >
                                Brahman
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Identity"
                              >
                                Absolute Ground – Impersonal, Unqualified
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Mode of Being"
                              >
                                Unmanifest
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Core Insight"
                              >
                                Being requires a non-conditioned Ground
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Tier"
                              >
                                02
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Name"
                              >
                                Divine Infinite Being
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Identity"
                              >
                                Psyche = Singularity, Geometric Archetypal Field
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Mode of Being"
                              >
                                Structured Consciousness
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Core Insight"
                              >
                                The observer is the Singularity, all form is
                                projected meaning
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Tier"
                              >
                                03
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Name"
                              >
                                Parental Monad
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Identity"
                              >
                                Kali–Krishna– Personal God in Total Reciprocity
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Mode of Being"
                              >
                                Relational Divinity
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Core Insight"
                              >
                                The Absolute loves, plays, transforms and
                                redeems in personal form
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology table-bottom-content-wrapper-ontology">
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          The Ontological Triad of the Divine, corrected for
                          precision and clarity:
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          I. <span className="common_bold_font">Brahman</span>{" "}
                          <span className="common_span_color_orange">
                            (Innermost)
                          </span>
                          : The pure, impersonal ground of all being — nondual,
                          unmanifest, unconditioned.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          II.{" "}
                          <span className="common_bold_font">
                            Divine Infinite Being
                          </span>{" "}
                          <span className="common_span_color_orange">
                            (Middle layer)
                          </span>
                          : The identity of psyche and singularity — the
                          structured reality from which archetypes and geometry
                          arise.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology">
                          III.{" "}
                          <span className="common_bold_font">
                            Parental Monad
                          </span>{" "}
                          <span className="common_span_color_orange">
                            (Kali-Krishna) (Outermost)
                          </span>
                          : The culmination of divinity into personal,
                          relational, and mythic presence — the God who loves,
                          relates, transforms and reveals.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block20">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_right">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block20_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>
                    <div className="ontology_heading_wrapper">
                      <h2>Introduction</h2>
                      <h3>
                        TOWARD A{" "}
                        <span className="ontology_heading_of">UNIVERSAL</span>{" "}
                      </h3>
                      <h3>RATIONALE FOR </h3>
                      <h3>
                        <span className="ontology_heading_god">
                          PARTICULAR{" "}
                        </span>{" "}
                        WORSHIP
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block21">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_left">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block21_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h2 className="common_leftright_pattern_block_heading_ontology">
                        The Perennial Path and the Purposeful Embrace of Krishna
                        and Kali
                      </h2>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology">
                        <p className="common_leftright_pattern_block_paragraph_ontology ">
                          In the grand spiritual inheritance of humanity, the
                          worship of the Divine—whether expressed through god,
                          goddess, form, or formlessness—emerges not as a relic
                          of tribal superstition, but as a profound orientation
                          of the soul toward the Real. Across millennia and
                          continents, in caves, temples, forests, deserts, and
                          cathedrals, the human being has sought not merely to
                          explain existence, but to participate in it, to align
                          with it, to surrender to what is both greater and more
                          intimate than the isolated ego.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology ">
                          This perennial drive—what Aldous Huxley and Frithjof
                          Schuon called the Perennial Philosophy— recognizes
                          that behind the apparent diversity of religious
                          expression lies a universal metaphysical foundation:
                          that reality is One, that it is knowable through inner
                          transformation, and that it communicates itself
                          through various theophanies, scriptures, avatars, and
                          archetypes in time and culture. In this view, all
                          authentic religious traditions are valid, for they are
                          rays of the same Sun, adapted to the psychological,
                          geographical, and karmic conditions of their
                          receivers.
                        </p>

                        <p className="common_leftright_pattern_block_paragraph_ontology ">
                          But acknowledging the unity of all truth does not
                          render all paths philosophically or liturgically
                          equivalent in every dimension. The Perennialist does
                          not claim that all deities, scriptures, or rituals are
                          identical in richness, depth, or degree of
                          self-revelation. Rather, just as the sunlight may be
                          refracted through different prisms with greater or
                          lesser clarity, some divine figures have developed in
                          human culture with extraordinary depth, philosophical
                          coherence, and mystical completeness. Their archetypes
                          have unfolded organically, not by political force or
                          theological suppression, but through centuries of
                          scripture, poetry, liturgy, and the inner experiences
                          of saints and sages. They form not only living paths
                          to the Divine—they are living mirrors of the Divine
                          itself, in its most accessible and exalted form.
                        </p>
                        <p className="common_leftright_pattern_block_paragraph_ontology ">
                          n what follows, I present the case for two such
                          figures: Krishna and Kali. These two—one traditionally
                          masculine, the other feminine—are not merely members
                          of a Hindu pantheon. They are global spiritual
                          archetypes, whose depth of literary revelation, ritual
                          sophistication, philosophical integration, and
                          emotional and mystical accessibility place them at the
                          highest summit of divine expression available to human
                          worship.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block22">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_right">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block22_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h2 className="common_leftright_pattern_block_heading_ontology">
                        THE CENTER: Krishna as the Infinite Singularity — Self
                        Revealed as All
                      </h2>
                      <div className="common_leftright_pattern_block_quotation_wrapper">
                        <p className="common_leftright_pattern_block_quotation common_italic_text">
                          “I am the Self, O Gudakesha, seated in the hearts of
                          all beings; I am the beginning, the middle, and the
                          end of all beings.”
                        </p>
                        <p className="common_leftright_pattern_block_quotation_owner">
                          — Bhagavad Gita 10.20
                        </p>
                      </div>
                      <p className="common_leftright_pattern_block_paragraph_ontology common_bold_font">
                        Why Krishna?
                      </p>

                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        Because Krishna is not only a god, or even the supreme
                        deity of a sect — he is the Singularity itself, the
                        psyche revealed as infinite, the Self who speaks with a
                        human voice. In the context of our cosmology, Krishna is
                        the gravitational center of all reality: that which is
                        eternal, coherent, radiant, and personal. He is not
                        merely a divine being — he is being itself, revealed in
                        human intimacy.
                      </p>

                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        Krishna and the Singularity
                      </h3>
                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        In Vedantic cosmology, the Paramatma (Supreme Self) is
                        the inner observer in all living beings. The Bhagavad
                        Gita, particularly Chapter 10 (Vibhuti Yoga), presents
                        Krishna as this indwelling consciousness who
                        simultaneously exists within every heart and as the
                        universal singularity from which all arises.
                      </p>
                      <ul className="common_bulletpoint_wrapper_ontology">
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint common_span_color_orange">
                          In 10.42, Krishna declares: “With a single fragment of
                          Myself I pervade and support this entire universe.”
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint common_span_color_orange">
                          In 2.12, he removes linear temporality: “Never was
                          there a time when I did not exist, nor you, nor all
                          these kings…”
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          And it is spoken of him in the Bhagavata Purana
                          10.14.11{" "}
                          <span className="common_span_color_orange">
                            “What am I, a small creature measuring seven spans
                            of my own hand? I am enclosed in a potlike universe
                            composed of material nature, the total material
                            energy, false ego, ether, air, water, and earth. And
                            what is Your glory? Unlimited universes pass through
                            the pores of Your body just as particles of dust
                            pass through the openings of a screened window.”
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block23">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_left">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block23_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        This is not the boast of a mythic hero — it is a
                        metaphysical statement about the core of experience. In
                        our expanded model: Krishna is the Singularity that
                        exists at every point in spacetime, and at the heart of
                        every being. And not only this Krishna is the
                        multivariate expression of the entire Multiverse, a
                        vision of the Multiverse in String Theory realized by
                        the mystics of India centuries before its discovery.
                      </p>
                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        This aligns directly with the psyche = singularity
                        principle. Krishna speaks the Self — not in abstraction,
                        but as a person. This is why Krishna is friend, child,
                        lover, and the disciplined teacher and guru: He is the
                        divine mirror, offering the totality of intimacy from
                        within the singular core of being.
                      </p>
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        Krishna and the Threefold Path
                      </h3>
                      <p className="common_leftright_pattern_block_paragraph_ontology common_medium_font">
                        Unlike abstract depersonalized metaphysics, Krishna
                        teaches a complete soteriology:
                      </p>

                      <ul className="common_bulletpoint_wrapper_ontology">
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          Jnana Yoga: The path of philosophical realization —
                          the discernment of Self from non-Self.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          Karma Yoga: The path of selfless action, rooted in
                          detachment and dharma.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          Bhakti Yoga: The path of devotional love, through
                          which the finite opens to the Infinite.
                        </li>
                      </ul>
                      <p className="common_leftright_pattern_block_paragraph_ontology common_medium_font">
                        These are not separate paths — they are threefold
                        reflections of the psyche-Singularity model:
                      </p>

                      <ul className="common_bulletpoint_wrapper_ontology">
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          Jnana corresponds to the witness — the Atman aware of
                          its identity with Brahman.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          Karma corresponds to the observer engaging the
                          projected field of Maya with awareness.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          Bhakti corresponds to the recognition of Self in other
                          — the sacred fusion of soul with Soul.
                        </li>
                      </ul>
                      <p className="common_leftright_pattern_block_paragraph_ontology ">
                        Through Krishna, the Singularity becomes relational
                        without losing its absoluteness. It is the only deity in
                        world scripture who directly speaks as the Self of all
                        beings while still inviting loving surrender, not fear.
                        Although this can be said of Lord Siva, of whom we honor
                        and venerate, it is only Krishna and the Divine
                        Personality of Godhead that is said to be the center of
                        the entire Multiverse, so be it said eternal inflation
                        itself bubbling into all the infinite universes as their
                        very center.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block24">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_right">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block24_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h2 className="common_leftright_pattern_block_heading_ontology">
                        THE HORIZON: Kali as the Cosmic Boundary — The Void Made
                        Visible
                      </h2>
                      <div className="common_leftright_pattern_block_quotation_wrapper">
                        <p className="common_leftright_pattern_block_quotation common_italic_text">
                          “Kali is none other than Brahman Itself... She is not
                          limited by name and form.”
                        </p>
                        <p className="common_leftright_pattern_block_quotation_owner">
                          — Mahanirvana Tantra 4.20
                        </p>
                      </div>
                      <p className="common_leftright_pattern_block_paragraph_ontology common_bold_font">
                        Why Kali?
                      </p>

                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        Because no other goddess or god reveals the raw Absolute
                        like Kali. If Krishna is the center, Kali is the
                        spherical boundary, the very womb and void — the event
                        horizon beyond which no ego survives. She is the
                        boundary condition of existence, the veil that reveals
                        rather than conceals, the two-dimensional razor’s edge
                        of cosmic truth where spacetime ends and pure awareness
                        begins.
                      </p>

                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        Kali and the Horizon
                      </h3>
                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        In the metaphysical language of physics, the event
                        horizon of the universe is where space and time cease to
                        function as we know them. This is the boundary of all
                        light, the cosmic yoni, the ultimate container of
                        becoming.
                      </p>
                      <p className="common_leftright_pattern_block_paragraph_ontology common_bold_font">
                        In Tantric philosophy, Kali is that horizon:
                      </p>
                      <ul className="common_bulletpoint_wrapper_ontology">
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          She is Kala{" "}
                          <span className="common_span_color_orange">
                            (Time)
                          </span>{" "}
                          in its devouring form — the force that collapses all
                          phenomena into the Real.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          She is Shakti in its naked state — stripped of mask
                          and pretense, truth without comfort.
                        </li>
                      </ul>
                      <p className="common_leftright_pattern_block_paragraph_ontology ">
                        Her garland of skulls, her crimson tongue, her naked
                        dance — these are not symbols of fear. They are the
                        iconography of boundary dissolution. She stands over the
                        chest of Shiva not in domination, but in paradox: Time
                        dancing over Eternity, Form upon Formlessness.
                      </p>
                      <p className="common_leftright_pattern_block_paragraph_ontology ">
                        In our framework, Kali is the 2D holographic horizon
                        that encodes the universe — both projection and
                        boundary. She is the membrane of manifestation, the
                        field of Yoga Maya through which form arises and
                        dissolves. And, like the event horizon, she is timeless,
                        for she exists outside the flow of spacetime.
                      </p>
                      <p className="common_leftright_pattern_block_paragraph_ontology ">
                        She is not a goddess in time and Maya and the
                        holographic body of the physical cosmos — she is time’s
                        origin and terminus. She is the destroyer of all
                        illusion — she is the truth that was hidden by form.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block25">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_left">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block25_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        Kali and Liberation
                      </h3>
                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        In scriptures such as the Kali Tantra, Devi Mahatmya,
                        and Mahanirvana Tantra, Kali is not worshipped merely
                        for worldly benefits. She is worshipped as Mahavidya —
                        the supreme wisdom — because her terrifying form reveals
                        the impermanence of all identity.
                      </p>
                      <ul className="common_bulletpoint_wrapper_ontology">
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          In Karpuradi Stotra, it is said: “Even the one who
                          knows Brahman is liberated only when he surrenders to
                          Kali.”
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          In Shiva Purana, she is revealed as “the dark womb of
                          all, from which creation and destruction arise.”
                        </li>
                      </ul>
                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        In other words, liberation is not possible without
                        meeting Kali — the horizon must be encountered and
                        crossed. She is both the veil and its tearing, both the
                        illusion and the unmaking of illusion.
                      </p>

                      <p className="common_leftright_pattern_block_paragraph_ontology common_medium_font">
                        In this, she parallels the event horizon of a black
                        hole:
                      </p>

                      <ul className="common_bulletpoint_wrapper_ontology">
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          Everything falls in and cannot return.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          Yet, per the holographic principle, nothing is truly
                          lost — all is encoded on the surface.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          In Kali’s dance, we fall into eternity, and discover
                          that we were never separate.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block26">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_right">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block26_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>
                    <div className="common_leftright_pattern_block_content_ontology">
                      <h2 className="common_leftright_pattern_block_heading_ontology">
                        Krishna and Kali: The Singularity and the Boundary — The
                        Divine Pair of Ultimate Reality
                      </h2>
                      <div className="table-wrapper-ontology">
                        <table className="data-table-ontology">
                          <thead>
                            <tr className="table-row-ontology">
                              <th className="table-header-ontology">Axis</th>
                              <th className="table-header-ontology">Krishna</th>
                              <th className="table-header-ontology">
                                Function
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Axis"
                              >
                                Cosmic Function
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Krishna"
                              >
                                The Singularity – the center of Self
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Function"
                              >
                                The Boundary – the womb and edge of experience
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Axis"
                              >
                                Symbolism
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Krishna"
                              >
                                Light, Witness, Intelligence
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Function"
                              >
                                Darkness, Void, Dissolution
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Axis"
                              >
                                Voice
                              </td>
                              <td
                                className="table-cell-ontology common_span_color_orange"
                                data-th="Krishna"
                              >
                                “I am the Self in all beings.” (Gita 10.20)
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Function"
                              >
                                “She is the void beyond name and form.” (MNT
                                4.20)
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Axis"
                              >
                                Path
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Krishna"
                              >
                                Teaching, Synthesis, Relational Love
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Function"
                              >
                                Silence, Devouring, Direct Revelation
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Axis"
                              >
                                Liberation Style
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Krishna"
                              >
                                Integrative – through devotion and realization
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Function"
                              >
                                Absolute – through ego annihilation
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block27">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_left">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block27_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <p className="common_leftright_pattern_block_paragraph_ontology common_bold_font">
                        Together, they are the dynamic non-duality of the Real:
                      </p>

                      <ul className="common_bulletpoint_wrapper_ontology">
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          Krishna is the center that sings — the One that speaks
                          from within.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          Kali is the edge that devours — the One that frees
                          through transformation and death.
                        </li>
                      </ul>
                      <p className="common_leftright_pattern_block_paragraph_ontology common_bold_font">
                        In their union, you have the total map of sacred
                        reality:
                      </p>
                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        The Self that radiates, and the Void that reflects.
                        <br />
                        The lover who dwells within you, and the Mother who
                        strips you of illusion.
                        <br />
                        The gravitational core, and the cosmic veil.
                        <br />
                        The Singularity, and the Horizon.
                      </p>

                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        This essay does not argue for the exclusivity of these
                        two revelations. It argues for their exemplarity. In a
                        world fragmented by relativism and religious tribalism,
                        we are invited not merely to affirm all paths, but to
                        walk those which offer the most clarity, depth, and
                        transformation. Krishna and Kali represent the pinnacle
                        of the divine spectrum, the poles of cosmic play and
                        cosmic ground, and to embrace them is to embrace not
                        only the God or Goddess—but the very process of divine
                        becoming in human consciousness. And they are One,
                        Kali-Krishna.
                      </p>
                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        To worship Krishna and Kali, then, is not to deny the
                        validity of other paths. It is to say: here, the light
                        burns brightest.
                      </p>
                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        Here, the form most fully reflects the formless.
                        <br />
                        Here, the real comes closest to touching the heart of
                        the seeker.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block28">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_right">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block28_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h2 className="common_leftright_pattern_block_heading_ontology">
                        Kali-Krishna: The Supreme Dyad of the Divine Archetype
                      </h2>

                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        Where the Infinite Takes Form as Co-equal Masculine and
                        Feminine
                      </h3>
                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        If we are to speak of divinity in its most complete
                        form—not only in abstract metaphysical categories but in
                        its revealed and accessible expression to humanity—then
                        we must eventually speak of duality in unity. All
                        traditions that reach maturity arrive at the recognition
                        that the divine is not singular in gender, not static in
                        essence, and not solely transcendent. The full
                        revelation of the Divine—when it chooses to appear in
                        history, mythology, and the mystical imagination—emerges
                        as a polarity that is not division, but dynamic
                        completeness.
                      </p>

                      <p className="common_leftright_pattern_block_paragraph_ontology ">
                        In this light, we turn to the archetypal pair of
                        Kali-Krishna: the masculine and feminine faces of the
                        Absolute, not as separate deities, but as the living
                        dialectic of consciousness and energy, love and death,
                        joy and truth. This is not the mere pairing of gods for
                        narrative balance—it is the emergence of metaphysical
                        co-equality in spiritual form.
                      </p>
                      <p className="common_leftright_pattern_block_paragraph_ontology ">
                        Where Krishna is the eternal witness, the divine lover,
                        the orchestrator of dharma, the Self behind all
                        selves—Kali is the space in which he dances, the force
                        that animates his lila, and the time that dissolves all
                        appearances back into source. Krishna smiles while Kali
                        roars, but both are expressions of the same nondual
                        source: one still, one wild—both divine.
                      </p>
                      <p className="common_leftright_pattern_block_paragraph_ontology ">
                        In Tantric cosmology, Shiva without Shakti is a corpse{" "}
                        <span className="common_span_color_orange">
                          (shava)
                        </span>
                        , and Shakti without Shiva is motion without center.
                        Likewise, Krishna without Kali is ecstasy without
                        ground, and Kali without Krishna is power without
                        direction. But together, they form the eternal spiral of
                        becoming—the Yin and Yang of Hindu metaphysics, though
                        deeper still. In many esoteric traditions, they are
                        understood not merely as lovers or divine consorts, but
                        as one being in two poles, continually cycling through
                        manifest and unmanifest form.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block29">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_left">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block29_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        To affirm Kali-Krishna is to reject the false absolutism
                        of either-only transcendence or only immanence. It is to
                        embrace a spiritual philosophy in which the dance of
                        duality is the gateway to the nondual, and where the
                        heart and the void are not opposites but aspects of the
                        same mystery.
                      </p>
                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        This is the expression of Polytheistic Monism, where the
                        masculine and feminine are one, co-equal and
                        irremovable. It is revelatory ontology—an invitation to
                        see the personal and impersonal, the intimate and the
                        terrifying, the erotic and the silent, not as
                        contradictions but as co-dependent expressions of the
                        Real.
                      </p>
                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        Thus, when we turn to the individual revelatory streams
                        of Krishna and Kali, we are not separating what is
                        whole—we are approaching the same sacred mountain from
                        two interwoven trails. Krishna teaches from the center
                        of the battlefield; Kali dances at the edge of the
                        cremation ground. But both offer the same truth: You are
                        not what dies. You are not what desires. You are That.
                      </p>
                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        Let us now approach each face of this supreme dyad with
                        the reverence and precision they deserve.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block30">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_right">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block30_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h2 className="common_leftright_pattern_block_heading_ontology">
                        A Philosophical Argument for the Worship of Krishna
                        Based on the Quantity, Continuity, and Depth of
                        Revelatory Development
                      </h2>

                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        I. Introduction: Why Worship?
                      </h3>

                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        Worship, in its purest form, arises not from dogma, but
                        from the encounter with transcendence—an archetype that
                        reveals itself through scripture, mystical experience,
                        philosophy, and devotion, evolving across centuries. It
                        is not only the truth of a deity that warrants worship,
                        but the sheer depth and consistency of its
                        self-revelation.
                      </p>

                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        When measured by these criteria, Krishna emerges as the
                        most comprehensively revealed, philosophically
                        interpreted, and devotionally alive deity in human
                        spiritual history outside the Abrahamic tradition—and
                        depending on your category of reference, perhaps even
                        including it.
                      </p>
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        II. The Scope of Revelatory Material
                      </h3>
                      <h3 className="common_leftright_pattern_block_subheading_ontology">
                        1. Canonical Textual Revelation
                      </h3>

                      <ul className="common_bulletpoint_wrapper_ontology">
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          <span className="common_bold_font">
                            Mahabharata{" "}
                            <span className="common_span_color_orange">
                              (~400 BCE–400 CE)
                            </span>
                            :
                          </span>{" "}
                          Krishna as divine strategist, statesman, avatar, and
                          friend.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          <span className="common_bold_font">
                            Bhagavad Gita{" "}
                            <span className="common_span_color_orange">
                              (c. 200 BCE–100 CE)
                            </span>
                            :
                          </span>{" "}
                          Direct speech of Krishna as the Supreme Self, teacher
                          of karma, jnana, and bhakti yoga.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          <span className="common_bold_font">
                            Harivamsa, Vishnu Purana, Bhagavata Purana:{" "}
                          </span>
                          elaborate portrayals of Krishna’s cosmic, moral, and
                          erotic dimensions.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          <span className="common_bold_font">
                            Upanishadic references:{" "}
                          </span>
                          Krishna as the inner Self{" "}
                          <span className="common_span_color_orange">
                            (Atman)
                          </span>
                          , especially in Gopala-Tapani and Krishna Upanishad.
                        </li>
                      </ul>
                      <p className="common_leftright_pattern_block_quotation common_italic_text">
                        Unlike the Biblical God who speaks largely through
                        intermediaries (prophets), Krishna speaks directly in a
                        divinely dramatic and pedagogical form, through
                        narrative and philosophical exposition.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block31">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_left">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block31_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology ">
                        2. Philosophical Exposition and Interpretation
                      </h3>

                      <ul className="common_bulletpoint_wrapper_ontology">
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint common_bold_font">
                          Vedanta traditions:
                        </li>
                      </ul>
                      <ul className="common_bulletpoint_wrapper_ontology common_subbulletpoint_wrapper_ontology">
                        <li className="common_leftright_pattern_block_paragraph_ontology blue_bulletpoint ">
                          <span className="common_bold_font">Shankara:</span>{" "}
                          sees Krishna as the symbol of Saguna Brahman{" "}
                          <span className="common_span_color_orange">
                            (the Absolute Reality)
                          </span>
                          , the bridge to Nirguna{" "}
                          <span className="common_span_color_orange">
                            (formless, changeless, eternal, and beyond all
                            conceptual distinctions)
                          </span>
                          .
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology blue_bulletpoint ">
                          <span className="common_bold_font">Ramanuja:</span>{" "}
                          Krishna is the immanent and loving Brahman, the
                          Supreme Person{" "}
                          <span className="common_span_color_orange">
                            (Purushottama)
                          </span>
                          .
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology blue_bulletpoint ">
                          <span className="common_bold_font">Madhva:</span>{" "}
                          Krishna is eternally distinct yet accessible, a
                          dualistic Absolute.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology blue_bulletpoint common_span_color_orange">
                          <span className="common_bold_font">Chaitanya:</span>{" "}
                          integrates Achintya Bheda Abheda (inconceivable
                          oneness and difference), revealing Krishna as both
                          lover and Beloved, immanent and transcendent. (a very
                          core tenant in the Central Doctrine)
                        </li>
                      </ul>
                      <ul className="common_bulletpoint_wrapper_ontology">
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint common_bold_font">
                          These are not theological embellishments—they are
                          school-defining metaphysical systems rooted in
                          Krishna’s words and acts.
                        </li>
                      </ul>
                      <p className="common_leftright_pattern_block_quotation common_italic_text">
                        Krishna is unique in that the vast agency of his
                        archetype functions as the direct source for competing
                        but co-valid philosophical systems—a sign of divine
                        super-abundance rather than doctrinal confusion.
                      </p>
                      <h3 className="common_leftright_pattern_block_subheading_ontology ">
                        3. Revelation Through Devotional Experience (Bhakti)
                      </h3>

                      <ul className="common_bulletpoint_wrapper_ontology ">
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          <span className="common_bold_font">
                            Alvars and Nayanmars{" "}
                            <span className="common_span_color_orange">
                              (Tamil Nadu)
                            </span>{" "}
                            :
                          </span>{" "}
                          sees Krishna as the symbol of Saguna Brahman Krishna
                          as the divine beloved, experienced through ecstatic
                          union.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          <span className="common_bold_font">
                            Jayadeva’s Gita Govinda:
                          </span>{" "}
                          reveals Krishna’s lila{" "}
                          <span className="common_span_color_orange">
                            (divine play)
                          </span>{" "}
                          as a path to transcendence through erotic mysticism.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          <span className="common_bold_font">
                            Mirabai, Surdas, Chaitanya Mahaprabhu:
                          </span>{" "}
                          Krishna is the ultimate experiential Absolute—the goal
                          of love, surrender, madness, and song.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          <span className="common_bold_font">
                            Modern saints:
                          </span>{" "}
                          Ramakrishna, Aurobindo, and Prabhupada continue the
                          living lineage.
                        </li>
                      </ul>
                      <p className="common_leftright_pattern_block_quotation common_italic_text">
                        Krishna's worship is justified not only through
                        scripture, but through personal and collective mystical
                        experience, across centuries and cultures.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block32">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_right">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block32_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>
                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        I. Introduction: Why Worship?
                      </h3>
                      <h3 className="common_leftright_pattern_block_subheading_ontology ">
                        1. No Other Deity Embodies So Many Roles Simultaneously
                      </h3>
                      <div className="table-wrapper-ontology">
                        <table className="data-table-ontology">
                          <thead>
                            <tr className="table-row-ontology">
                              <th className="table-header-ontology">
                                Archetype
                              </th>
                              <th className="table-header-ontology">
                                Krishna’s Role
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Archetype"
                              >
                                Child-God
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Krishna’s Role"
                              >
                                Gopala, the divine child of Vrindavan
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Archetype"
                              >
                                Lover
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Krishna’s Role"
                              >
                                Rasa-lila with Radha: mystical eroticism as
                                union with God
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Archetype"
                              >
                                King
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Krishna’s Role"
                              >
                                Ruler of Dvaraka: sovereignty with compassion
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Archetype"
                              >
                                Friend
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Krishna’s Role"
                              >
                                Companion to Arjuna, Draupadi, Sudama: spiritual
                                intimacy
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Archetype"
                              >
                                Guru
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Krishna’s Role"
                              >
                                The divine teacher of the Gita
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Archetype"
                              >
                                Absolute
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Krishna’s Role"
                              >
                                Declares: "I am the source of all worlds" (Gita
                                10.8)
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology table-bottom-content-wrapper-ontology">
                        <p className="common_leftright_pattern_block_quotation common_italic_text">
                          Krishna is not a partial archetype—he is the totality
                          of archetypes made personal, and their reconciler.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block33">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_left">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block33_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        IV. Continuity and Organic Evolution
                      </h3>

                      <ul className="common_bulletpoint_wrapper_ontology">
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          From folk god to Supreme Brahman, Krishna evolved
                          organically, not by imposition but by experiential
                          realization and interpretive expansion.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          This continuity spans over 3,000 years—no theological
                          coercion, no historical collapse. Krishna’s identity
                          only deepens over time following a natural evolution
                          and flowering.
                        </li>
                      </ul>

                      <p className="common_leftright_pattern_block_quotation common_italic_text">
                        Such evolution is a sign not of human invention, but of
                        living revelation—a consciousness that grows with the
                        soul of humanity.
                      </p>
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        V. Comparative Perspective: Why Krishna Deserves Worship
                        Even With the Biblical God Included
                      </h3>

                      <div className="table-wrapper-ontology">
                        <table className="data-table-ontology">
                          <thead>
                            <tr className="table-row-ontology">
                              <th className="table-header-ontology">
                                Criterion
                              </th>
                              <th className="table-header-ontology">Krishna</th>
                              <th className="table-header-ontology">
                                Biblical God (YHWH/Theos)
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Criterion"
                              >
                                Direct revelatory speech
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Krishna"
                              >
                                Yes (Gita)
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Biblical God (YHWH/Theos)"
                              >
                                Often via prophets
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Criterion"
                              >
                                Archetypal complexity
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Krishna"
                              >
                                Multiform, intimate
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Biblical God (YHWH/Theos)"
                              >
                                Majestic, moralistic
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Criterion"
                              >
                                Ritual diversity
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Krishna"
                              >
                                Bhakti, mantra, tantra, lila
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Biblical God (YHWH/Theos)"
                              >
                                Temple, prayer, law
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Criterion"
                              >
                                Philosophical systems
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Krishna"
                              >
                                Integral to Vedanta
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Biblical God (YHWH/Theos)"
                              >
                                Applied externally (Aquinas, etc.)
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Criterion"
                              >
                                Mystical access
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Krishna"
                              >
                                Visions, union, madness
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Biblical God (YHWH/Theos)"
                              >
                                Fear, surrender, obedience
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology table-bottom-content-wrapper-ontology">
                        <p className="common_leftright_pattern_block_quotation common_italic_text">
                          Even including the biblical tradition, Krishna remains
                          more intimate, more accessible, more complete, and
                          more philosophically versatile.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block34">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_right">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block34_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>
                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        VI. Conclusion: Worship as Recognition of Complete
                        Revelation
                      </h3>
                      <p className="common_leftright_pattern_block_paragraph_ontology common_bold_font">
                        To worship Krishna is to recognize:
                      </p>
                      <ul className="common_bulletpoint_wrapper_ontology">
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          A being who has spoken directly, played freely, loved
                          erotically, ruled justly, and taught cosmically.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          A form who has inspired epic, commentary, song, and
                          surrender, without needing to divide history or demand
                          exclusive allegiance.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          A living archetype, whose energy flows not just
                          through India, but through any heart capable of
                          devotion, beauty, and truth.
                        </li>
                      </ul>

                      <p className="common_leftright_pattern_block_quotation common_italic_text">
                        “Whenever there is a decline in dharma… I manifest
                        myself.” (Bhagavad Gita 4.7)
                      </p>
                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        Worship is not commanded—it is compelled by the
                        revelation of Krishna’s fullness.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block35">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_left">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block35_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h2 className="common_leftright_pattern_block_heading_ontology">
                        A Philosophical Argument for the Worship of Shakti —
                        Centering Kali
                      </h2>

                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        Based on Continuous Revelatory Development, Archetypal
                        Completeness, and Philosophical Supremacy
                      </h3>
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        I. Introduction: Worship Rooted in Revelation and
                        Experience
                      </h3>
                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        Worship arises from the encounter with the Real—the
                        overwhelming force that is prior to language, yet which
                        reveals itself through symbol, vision, literature, and
                        ritual. When that encounter speaks in the voice of the
                        Eternal Feminine, it takes many forms—but none more
                        transforming, liberating, and philosophically complete
                        than Kali.
                      </p>

                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        Among the goddesses of the world, Kali stands alone as
                        the most existentially honest, philosophically radical,
                        and ritually profound manifestation of divinity. She is
                        Shakti at her rawest and most exalted—time, death,
                        space, womb, and transcendence in one image.
                      </p>
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        II. Scriptural and Philosophical Revelation of Kali
                      </h3>
                      <h3 className="common_leftright_pattern_block_subheading_ontology">
                        1. Scriptural Sources
                      </h3>

                      <ul className="common_bulletpoint_wrapper_ontology">
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          <span className="common_bold_font">
                            Devi Mahatmya{" "}
                            <span className="common_span_color_orange">
                              (c. 400–600 CE)
                            </span>
                            :
                          </span>{" "}
                          Kali emerges from the forehead of Durga in wrathful
                          splendor to destroy demonic forces. She is Chandi, the
                          unstoppable one. A concept that we have deeply
                          integrated into our school.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          <span className="common_bold_font">
                            Kalika Purana, Rudra Yamala Tantra, Mahanirvana
                            Tantra, and Devi Bhagavata Purana:{" "}
                          </span>
                          expound Kali as Adi Shakti, the source of all gods,
                          including Brahma, Vishnu, and Shiva as the cosmic womb
                          of the divine, but related in the Devi Bhagavata as
                          co-equal ot Krishna.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint ">
                          <span className="common_bold_font">
                            Upanishadic texts{" "}
                            <span className="common_span_color_orange">
                              (e.g., Kaulajnananirnaya, Devi Upanishad)
                            </span>
                            :
                          </span>{" "}
                          refer to her as the Supreme Brahman, beyond form and
                          duality.
                        </li>
                      </ul>
                      <p className="common_leftright_pattern_block_quotation common_italic_text">
                        These are not mere mythic embellishments—these are
                        direct declarations of ultimate metaphysical truth: Kali
                        is the Absolute.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block36">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_right">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block36_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>
                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology ">
                        2. Philosophical Themes Unique to Kali
                      </h3>
                      <div className="table-wrapper-ontology">
                        <table className="data-table-ontology">
                          <thead>
                            <tr className="table-row-ontology">
                              <th className="table-header-ontology">Theme</th>
                              <th className="table-header-ontology">
                                Kali's Role
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Theme"
                              >
                                Time (Kala)
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Kali's Role"
                              >
                                Kali is the devourer of time, and its
                                transcendent witness.
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Theme"
                              >
                                Death and Impermanence
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Kali's Role"
                              >
                                She is Mrityu, the death of the ego, the
                                stripping of all illusion.
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Theme"
                              >
                                Maya and Moksha
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Kali's Role"
                              >
                                She is both the veil and the force that rips it
                                away.
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Theme"
                              >
                                Chit-Shakti (Power of Consciousness)
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Kali's Role"
                              >
                                In Kashmir Shaivism and Shakta Vedanta, Kali is
                                the spanda, the vibration of conscious power.
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Theme"
                              >
                                Ground of Being
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Kali's Role"
                              >
                                In Tantra, she is the Yoni, the cosmic womb, the
                                space in which form arises, the great void.
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Theme"
                              >
                                Compassion through Terror
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Kali's Role"
                              >
                                She cuts away falsehood, ego, and ignorance to
                                reveal the Self. She does not "save" you—she
                                reveals that you never needed saving which is
                                only possible in the death of the ego.
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block37">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_left">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block37_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>
                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        III. Liturgical and Mystical Revelation
                      </h3>

                      <ul className="common_bulletpoint_wrapper_ontology">
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          <span className="common_bold_font">Kali Puja:</span> A
                          high Tantric ritual performed on new moon night, when
                          the veil between self and abyss is thinnest.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          <span className="common_bold_font">Mantras:</span>{" "}
                          Kreem, Om Krim Kalikayai Namah, Aim Hrim Klim
                          Chamundayai Vichche—each a coded invocation of
                          primordial sound-consciousness.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          <span className="common_bold_font">Yantras:</span> The
                          Kali Yantra—a mandala of inner dissolution and
                          rebirth.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          <span className="common_bold_font">
                            Tantric sadhana:
                          </span>{" "}
                          Includes cremation ground rituals, visualization of
                          Kali as one's own Self{" "}
                          <span className="common_span_color_orange">
                            (aham Kali)
                          </span>
                          , and total surrender{" "}
                          <span className="common_span_color_orange">
                            (prapatti)
                          </span>
                          .
                        </li>
                      </ul>

                      <p className="common_leftright_pattern_block_quotation common_italic_text">
                        Where other deities teach through morality or law, Kali
                        teaches through initiation into reality itself—the
                        stripping of all masks, even spiritual ones.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block38">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_right">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block38_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        IV. Kali as Philosophically Superior to Other Goddesses
                      </h3>

                      <div className="table-wrapper-ontology">
                        <table className="data-table-ontology">
                          <thead>
                            <tr className="table-row-ontology">
                              <th className="table-header-ontology">Goddess</th>
                              <th className="table-header-ontology">
                                Ontological Status
                              </th>
                              <th className="table-header-ontology">Role</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Goddess"
                              >
                                Mary{" "}
                                <span className="common_span_color_orange">
                                  (Christianity)
                                </span>
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Ontological Status"
                              >
                                Created being
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Role"
                              >
                                Intercessor, Mother
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Goddess"
                              >
                                Sophia{" "}
                                <span className="common_span_color_orange">
                                  (Gnosticism)
                                </span>
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Ontological Status"
                              >
                                Emanation of divine
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Role"
                              >
                                Wisdom, not Absolute
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Goddess"
                              >
                                Isis{" "}
                                <span className="common_span_color_orange">
                                  (Egypt)
                                </span>
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Ontological Status"
                              >
                                Cosmic principle
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Role"
                              >
                                Consort, magician
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Goddess"
                              >
                                Kuan Yin
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Ontological Status"
                              >
                                Bodhisattva
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Role"
                              >
                                Compassionate savior
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Goddess"
                              >
                                Kali / Shakti
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Ontological Status"
                              >
                                The Absolute
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Role"
                              >
                                Creator, Destroyer, Liberator, Being-Itself
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology table-bottom-content-wrapper-ontology">
                        <p className="common_leftright_pattern_block_quotation common_italic_text">
                          Kali is not in the universe. The universe is in her.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block39">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_left">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block39_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>
                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        V. Archetypal Necessity: Why the World Needs Kali
                      </h3>

                      <ul className="common_bulletpoint_wrapper_ontology">
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          In a world obsessed with light, comfort, and false
                          transcendence, Kali represents the shadow and the
                          truth.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          She is the wrath of the real against illusion, the
                          feminine Absolute that refuses to be domesticated.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          She embraces blood, birth, death, madness, orgasm,
                          terror, and silence—not as impurities, but as sacred
                          thresholds.
                        </li>
                      </ul>
                      <p className="common_leftright_pattern_block_quotation common_italic_text">
                        Kali completes the archetypal structure of divinity.
                        Where Krishna offers the cosmic play, Kali offers the
                        cosmic ground.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block40">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_right">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block40_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>

                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        VI. Comparative Revelation (Including the Biblical
                        Canon)
                      </h3>

                      <div className="table-wrapper-ontology">
                        <table className="data-table-ontology">
                          <thead>
                            <tr className="table-row-ontology">
                              <th className="table-header-ontology">Deity</th>
                              <th className="table-header-ontology">
                                Creative Evolution
                              </th>
                              <th className="table-header-ontology">
                                Philosophical Scope
                              </th>
                              <th className="table-header-ontology">
                                Liturgical Complexity
                              </th>
                              <th className="table-header-ontology">
                                Archetypal Breadth
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Deity"
                              >
                                YHWH
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Creative Evolution"
                              >
                                Frozen early
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Philosophical Scope"
                              >
                                High via interpretation
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Liturgical Complexity"
                              >
                                High (Temple, prayer)
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Archetypal Breadth"
                              >
                                King, Judge
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Deity"
                              >
                                Krishna
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Creative Evolution"
                              >
                                High
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Philosophical Scope"
                              >
                                Extremely high
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Liturgical Complexity"
                              >
                                High (Bhakti, Tantra)
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Archetypal Breadth"
                              >
                                Lover, Teacher, Self
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Deity"
                              >
                                Mary
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Creative Evolution"
                              >
                                Low{" "}
                                <span className="common_span_color_orange">
                                  (theologically fixed)
                                </span>
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Philosophical Scope"
                              >
                                Medium{" "}
                                <span className="common_span_color_orange">
                                  (iconic)
                                </span>
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Liturgical Complexity"
                              >
                                Very high
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Archetypal Breadth"
                              >
                                Mother, Mediatrix
                              </td>
                            </tr>
                            <tr className="table-row-ontology">
                              <td
                                className="table-cell-ontology"
                                data-th="Deity"
                              >
                                Kali / Shakti
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Creative Evolution"
                              >
                                Extreme
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Philosophical Scope"
                              >
                                Supreme
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Liturgical Complexity"
                              >
                                Tantric, ritual, poetic
                              </td>
                              <td
                                className="table-cell-ontology"
                                data-th="Archetypal Breadth"
                              >
                                All: Womb, Time, Truth, Void
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="common_leftright_pattern_block_paragraph_wrapper_ontology table-bottom-content-wrapper-ontology">
                        <p className="common_leftright_pattern_block_quotation common_italic_text">
                          Only Kali combines the uncontainable freedom of
                          creative mythos with the rigor of metaphysical
                          philosophy, and the raw power of direct mystical
                          experience.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
          <LazySection className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              <div className="common_leftright_pattern_block ontology_of_being_block41">
                <div className="common_leftright_pattern_content_commonwidth">
                  <div className="common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_left">
                    <div className="common_leftright_pattern_block_position_image_wrapper">
                      <Image
                        className="next_image"
                        src="/image/ontology-of-being-new/ontology_block41_img.webp"
                        alt="Block Content"
                        width={1200}
                        height={800}
                      />
                    </div>
                    <div className="common_leftright_pattern_block_content_ontology">
                      <h3 className="common_leftright_pattern_block_subheading_ontology common_span_textbg_blue">
                        VII. Conclusion: Worship as Surrender to Reality
                      </h3>
                      <p className="common_leftright_pattern_block_paragraph_ontology common_bold_font">
                        To worship Kali is to:
                      </p>
                      <ul className="common_bulletpoint_wrapper_ontology">
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          Accept the impermanence of all things as sacred.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          Recognize duality as illusion, and death as
                          transformation.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          See the cosmic womb and cosmic grave as the same
                          sacred space.
                        </li>
                        <li className="common_leftright_pattern_block_paragraph_ontology orange_bulletpoint">
                          Embrace feminine power not as gentle comfort, but as
                          the reality that devours falsity to reveal truth.
                        </li>
                      </ul>

                      <p className="common_leftright_pattern_block_quotation common_italic_text">
                        “Even time bows before Kali.”
                      </p>
                      <p className="common_leftright_pattern_block_paragraph_ontology">
                        Worship of Kali is not about seeking comfort. It is
                        about courageously aligning with the deepest truth of
                        existence.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
        </div>
      </div>

      {showOtherBlocks && (
        <>
          {/* ==================== modal =================== */}
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="banner_modal_main"
          >
            <Box className="banner_modal_box">
              <Typography
                id="modal-modal-description"
                sx={{ mt: 2 }}
                className="modal_banner"
                component="div"
              >
                <div className="sub_modal_banner">
                  <span className="close_btn" onClick={handleClose}>
                    <CloseIcon />
                  </span>

                  <Image
                    src={logoBanner}
                    alt="bannerLogo"
                    width={400}
                    height={100}
                    style={{ width: "100%", height: "100%" }}
                    priority={false}
                    placeholder="blur"
                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                  />
                </div>
              </Typography>
            </Box>
          </Modal>
        </>
      )}
    </>
  );
}

export default Index;
